/**
 * /eric/reports — Progression report queue (T-081, PR-21).
 *
 * Route config only. Component lives in eric.reports.lazy.tsx (code-split).
 * No loader, beforeLoad, or validateSearch.
 */

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/eric/reports')({});
